import ws from '../utils/ws';

/* Actions */

export const scansPaginatedList = (pageNumber, pageSize) => dispatch =>
  dispatch({
    type: SCANS_PAGINATED_LIST,
    payload: ws.get(`/scans/page/${pageNumber}/rows/${pageSize}`)
  });

export const setScanListVenues = venues => dispatch =>
  dispatch({
    type: 'SET_SCAN_LIST_VENUES',
    payload: venues
  });

export const setScanListDetectionLabels = labels => dispatch =>
  dispatch({
    type: 'SET_SCAN_LIST_DETECTION_LABELS',
    payload: labels
  });

export const setScanListModelNames = modelNames => dispatch =>
  dispatch({
    type: 'SET_SCAN_LIST_MODEL_NAMES',
    payload: modelNames
  });

/* Constants */

export const SCANS_PAGINATED_LIST = 'SCANS_PAGINATED_LIST';
export const SCANS_PAGINATED_LIST_PENDING = 'SCANS_PAGINATED_LIST_PENDING';
export const SCANS_PAGINATED_LIST_FULFILLED = 'SCANS_PAGINATED_LIST_FULFILLED';

export const SET_SCAN_LIST_VENUES = 'SET_SCAN_LIST_VENUES';
export const SET_SCAN_LIST_DETECTION_LABELS = 'SET_SCAN_LIST_DETECTION_LABELS';
export const SET_SCAN_LIST_MODEL_NAMES = 'SET_SCAN_LIST_MODEL_NAMES';
